<template>
  <div>
    <label :style="{ display: 'block' }" v-if="label">
      {{ label }} <span v-if="required" style="color: red;"> *</span>
    </label>

    <div class="tui-datepicker-input form-control tui-datetime-input tui-has-focus w-100">
      <input type="text" id="tui-date-picker-target" aria-label="Date-Time" ref="datepickerTarget" />
      <span class="tui-ico-date"></span>
    </div>

    <div id="tui-date-picker-container" ref="datepickerContainer" style="margin-top: -1px;"></div>
  </div>
</template>

<script>
import DatePicker from 'tui-date-picker';
import moment from 'moment';


DatePicker.localeTexts['de'] = {
  titles: {
    DD: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    D: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    MMMM: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    MMM: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
  },
  titleFormat: 'MMM yyyy',
  todayFormat: 'D, MMMM dd, yyyy',
  date: 'Datum',
  time: 'Zeit'
};

export default {
  name: 'TuiDatePicker',
  props: {
    initialDate: {
      type: [String, Date],
      default: () => new Date(),
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Date',
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm',
      //default: 'dd.mm.YYYY HH:mm',
    },
  },
  computed: {
    parsedDate() {

      return this.initialDate ? new Date(this.initialDate) : new Date();
    },
  },
  mounted() {
    const container = this.$refs.datepickerContainer;
    const target = this.$refs.datepickerTarget;


    this.datePicker = new DatePicker(container, {
      input: {
        element: target,
        format: 'yyyy-MM-dd HH:mm',
        //format: 'dd.mm.YYYY HH:mm',
      },
      language: 'de',
      date: this.parsedDate,
      timePicker: {
        showMeridiem: false,
        inputType: 'spinbox',
        minuteStep: 5
      },
    });

    this.datePicker.on('change', () => {
      const date = this.datePicker.getDate();
      const formattedDate = moment(date).format(this.dateFormat);
      this.$emit('dateChange', formattedDate);
    });
  },

  beforeUnmount() {
    if (this.datePicker) {
      this.datePicker.destroy();
    }
  },
};
</script>

<style scoped>
:deep(.tui-datepicker) {
  z-index: 100;
  transform: translateY(-100%);
}

.tui-datepicker-input {
  padding: 0;
  overflow: auto;
  border: 2px solid #dde2ec;
  height: auto;
}

.tui-datetime-input {
  min-width: 220px;
  height: 35px;
}

@media (max-width: 575.98px) {
  :deep(.tui-datepicker) {
    left: 50% !important;
    transform: translateX(-50%) translateY(-100%) !important;
  }

  .tui-datetime-input {
    min-width: 140px;
    width: 100%;
  }
}

</style>